module.exports = __webpack_public_path__ + "img/5636a6d.png";